// Пикер даты: ручной ввод с маской дд.мм.гггг + выбор даты в выпадающем календаре.
// Месяц переключается стрелками (выбор месяца/года селектами можно добавить позже).
// Неделя начинается с воскресенья — в соответствии с макетом.

const MONTHS = [
	"Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
	"Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь",
];

document.querySelectorAll(".form-date").forEach(initDatePicker);

function initDatePicker(root) {
	const input = root.querySelector(".form-date__input");
	const picker = root.querySelector(".form-date-picker");
	if (!input || !picker) return;

	const monthEl = picker.querySelector(".form-date-picker__month");
	const yearEl = picker.querySelector(".form-date-picker__year");
	const daysEl = picker.querySelector(".form-date-picker__days");
	const prevBtn = picker.querySelector("[data-date-prev]");
	const nextBtn = picker.querySelector("[data-date-next]");

	const today = new Date();
	let viewYear = today.getFullYear();
	let viewMonth = today.getMonth();
	let selected = null;

	const open = () => { root.classList.add("active"); reposition(); };
	const close = () => root.classList.remove("active");

	// если выпадашка вылезает за правый край окна — прижимаем её к правому краю поля
	function reposition() {
		const GUTTER = 8;
		picker.classList.remove("is-flipped");
		const rect = picker.getBoundingClientRect();
		if (rect.right > window.innerWidth - GUTTER) picker.classList.add("is-flipped");
	}

	// dd.mm.yyyy -> Date | null (с проверкой реальности даты)
	function parseInput() {
		const m = input.value.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
		if (!m) return null;
		const day = +m[1];
		const month = +m[2] - 1;
		const year = +m[3];
		const date = new Date(year, month, day);
		if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) return null;
		return date;
	}

	function format(date) {
		const dd = String(date.getDate()).padStart(2, "0");
		const mm = String(date.getMonth() + 1).padStart(2, "0");
		return `${dd}.${mm}.${date.getFullYear()}`;
	}

	function isSelected(day) {
		return (
			selected &&
			selected.getDate() === day &&
			selected.getMonth() === viewMonth &&
			selected.getFullYear() === viewYear
		);
	}

	function isToday(day) {
		const now = new Date();
		return (
			now.getDate() === day &&
			now.getMonth() === viewMonth &&
			now.getFullYear() === viewYear
		);
	}

	function render() {
		monthEl.textContent = MONTHS[viewMonth];
		yearEl.textContent = viewYear;
		daysEl.innerHTML = "";

		const firstWeekday = new Date(viewYear, viewMonth, 1).getDay(); // 0 — воскресенье
		const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();

		// пустые ячейки до первого дня месяца
		for (let i = 0; i < firstWeekday; i++) {
			const empty = document.createElement("span");
			empty.className = "form-date-picker__day-empty";
			daysEl.appendChild(empty);
		}

		for (let day = 1; day <= daysInMonth; day++) {
			const btn = document.createElement("button");
			btn.type = "button";
			btn.className = "btn btn--icon-48 form-date-picker__day";
			btn.dataset.day = day;
			btn.textContent = day;
			if (isSelected(day)) btn.classList.add("btn--Black", "is-selected");
			if (isToday(day)) btn.classList.add("is-today");
			daysEl.appendChild(btn);
		}
	}

	// показываем месяц введённой/выбранной даты, иначе текущий
	function syncView() {
		const parsed = parseInput();
		if (parsed) {
			selected = parsed;
			viewYear = parsed.getFullYear();
			viewMonth = parsed.getMonth();
		}
		render();
	}

	// маска дд.мм.гггг
	input.addEventListener("input", () => {
		const digits = input.value.replace(/\D/g, "").slice(0, 8);
		let value = digits.slice(0, 2);
		if (digits.length >= 3) value += "." + digits.slice(2, 4);
		if (digits.length >= 5) value += "." + digits.slice(4, 8);
		input.value = value;

		const parsed = parseInput();
		if (parsed) {
			selected = parsed;
			viewYear = parsed.getFullYear();
			viewMonth = parsed.getMonth();
			render();
		}
	});

	input.addEventListener("focus", () => { syncView(); open(); });
	input.addEventListener("click", () => { syncView(); open(); });

	prevBtn.addEventListener("click", () => {
		viewMonth--;
		if (viewMonth < 0) { viewMonth = 11; viewYear--; }
		render();
	});

	nextBtn.addEventListener("click", () => {
		viewMonth++;
		if (viewMonth > 11) { viewMonth = 0; viewYear++; }
		render();
	});

	daysEl.addEventListener("click", (e) => {
		const btn = e.target.closest(".form-date-picker__day");
		if (!btn) return;
		selected = new Date(viewYear, viewMonth, +btn.dataset.day);
		input.value = format(selected);
		// Программная установка value не вызывает change — диспатчим вручную (для автосейва).
		input.dispatchEvent(new Event("change", { bubbles: true }));
		render();
		close();
	});

	document.addEventListener("click", (e) => {
		if (!root.contains(e.target)) close();
	});

	window.addEventListener("resize", () => {
		if (root.classList.contains("active")) reposition();
	});

	render();
}
